import { render } from "./About.vue?vue&type=template&id=2cf5fbd6"
const script = {}
script.render = render

export default script